/**
 * What the page has loaded from the server, and nothing it has derived.
 *
 * The store holds server answers verbatim: the machine record, the masters, the
 * recipes in force, the four calibration slots. Edits in progress live in the
 * component's own state until they are saved, because an unsaved figure is not
 * a fact about the pantry and should not look like one to anything else in the
 * app.
 */
const initialState = {
    machine: null,
    beverages: [],
    ingredients: [],
    pantry: null,
    recipes: [],
    calibrationSlots: [],
    recipeHistory: [],
    calibrationHistory: [],
    loadError: null,
};

const recipeCalibrationReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'RC_MACHINE': {
            return { ...state, machine: action.payload || null };
        }
        case 'RC_MASTERS': {
            return {
                ...state,
                beverages: action.payload?.beverages || [],
                ingredients: action.payload?.ingredients || [],
            };
        }
        case 'RC_RECIPES': {
            return {
                ...state,
                pantry: action.payload?.pantry || state.pantry,
                recipes: action.payload?.recipes || [],
                // listRecipes returns the master too; it is the same data as
                // RC_MASTERS and is ignored here so there is one source of rows.
            };
        }
        case 'RC_CALIBRATION': {
            return {
                ...state,
                pantry: action.payload?.pantry || state.pantry,
                calibrationSlots: action.payload?.slots || [],
            };
        }
        case 'RC_RECIPE_HISTORY': {
            return { ...state, recipeHistory: action.payload?.versions || action.payload?.recipes || [] };
        }
        case 'RC_CALIBRATION_HISTORY': {
            return { ...state, calibrationHistory: action.payload?.versions || action.payload?.calibrations || [] };
        }
        case 'RC_LOAD_ERROR': {
            return { ...state, loadError: action.payload || null };
        }
        case 'RC_RESET': {
            return { ...initialState };
        }
        default:
            return state;
    }
};

export default recipeCalibrationReducer;
